import { ViewModelMovimentacaoEmp } from "./viewModelMovimentacaoEmp.model";
import { WebContratoEmp } from "./webContratoEmp.model";

export class ViewModelWebContratoEmp {
    webContratoEmp: WebContratoEmp = new WebContratoEmp();
    movimentoContratoEmps: ViewModelMovimentacaoEmp[] = [];
}